<template>
	<div class="pages-body notfound-page flex flex-column">
		<div class="topbar p-3 flex justify-content-between flex-row align-items-center">
			<router-link class="topbar-left ml-3 flex" to="/">
				<div class="logo">
					<!-- <img src="layout/images/logo2x.png" alt=""/> -->
					<img id="logo" src="layout/images/seway-blanco.png" alt="ultima-layout" style="height: 3.5rem">
				</div>
			</router-link>
			<router-link class="topbar-right mr-3 flex" to="/">
				<Button type="button" label="HOME"
					class="p-button-text p-button-plain topbar-button"></button>
			</router-link>
		</div>

		<div class="align-self-center mt-auto mb-auto">
			<div class="pages-panel card flex flex-column">
				<div class="pages-header px-3 py-1">
					<h2>LA URL NO EXISTE</h2>
				</div>
				<div class="card mt-3 px-6">
					<img src="layout/images/pages/404.png" alt=""/>
				</div>
				<div class="pages-detail pb-6">La URL ingresada no existe.</div>
				<router-link to="/">
					<Button type="button" label="VOLVER AL INICIO" class="p-button-text"></Button>
				</router-link>
			</div>
		</div>
	</div>

</template>

<script>
</script>

<style scoped>

</style>
